import React,{useState,useEffect} from 'react';
import * as LuIcons from 'react-icons/lu';
const { LuMessageSquare, LuX, LuSend } = LuIcons;
import SafeIcon from './common/SafeIcon';
import {motion,AnimatePresence} from 'framer-motion';
import {useLanguage} from '../contexts/LanguageContext';

const Chatbot: React.FC=()=> {
  const [isOpen,setIsOpen]=useState(false);
  const {t}=useLanguage();
  const [messages,setMessages]=useState<{text: string,isBot: boolean}[]>([]);
  const [input,setInput]=useState("");

  useEffect(()=> {
    setMessages([ {text: t('chatbotWelcome'),isBot: true} ]);
  },[t]);

  const handleSend=(e: React.FormEvent)=> {
    e.preventDefault();
    if (!input.trim()) return;
    const newMessages=[...messages,{text: input,isBot: false}];
    setMessages(newMessages);
    setInput("");
    setTimeout(()=> {
      setMessages([...newMessages,{text: t('chatbotReply'),isBot: true}]);
    },1000);
  };

  return ( 
    <> 
      <div className="fixed bottom-6 left-6 z-40"> 
        {!isOpen && ( 
          <div className="relative"> 
            <button onClick={()=> setIsOpen(true)} className="bg-gradient-to-br from-be-france to-be-night text-white p-3 rounded-full shadow-xl shadow-blue-600/40 hover:brightness-110 transition-all animate-float flex items-center gap-2"> 
              <SafeIcon icon={LuMessageSquare} size={20} /> 
              <span className="hidden md:inline font-semibold text-xs">{t('needHelp')}</span> 
            </button> 
          </div> 
        )} 
      </div> 
      <AnimatePresence> 
        {isOpen && ( 
          <motion.div initial={{opacity: 0,y: 50,scale: 0.9}} animate={{opacity: 1,y: 0,scale: 1}} exit={{opacity: 0,y: 50,scale: 0.9}} className="fixed bottom-6 left-6 z-50 w-72 md:w-80 bg-white dark:bg-gray-800 rounded-2xl shadow-2xl shadow-black/20 border border-gray-200 dark:border-gray-700 overflow-hidden flex flex-col max-h-[400px]"> 
            <div className="bg-gradient-to-r from-be-night to-be-france p-3 text-white flex justify-between items-center shadow-md"> 
              <div className="flex items-center gap-2"> 
                <div className="w-1.5 h-1.5 bg-green-400 rounded-full animate-pulse"></div> 
                <h4 className="font-bold text-xs">{t('chatbotTitle')}</h4> 
              </div> 
              <button onClick={()=> setIsOpen(false)} className="hover:bg-white/20 rounded p-1 transition-colors"> 
                <SafeIcon icon={LuX} size={16} /> 
              </button> 
            </div> 
            <div className="flex-1 p-3 overflow-y-auto bg-gray-50 dark:bg-gray-900 space-y-2.5 h-64"> 
              {messages.map((msg,idx)=> ( 
                <div key={idx} className={`flex ${msg.isBot ? 'justify-start' : 'justify-end'}`}> 
                  <div className={`max-w-[85%] p-2.5 rounded-lg text-xs shadow-sm ${msg.isBot ? 'bg-white dark:bg-gray-700 border border-gray-200 dark:border-gray-600 text-gray-800 dark:text-gray-100 rounded-tl-none' : 'bg-gradient-to-br from-be-france to-be-night text-white rounded-tr-none shadow-blue-500/20'}`}> 
                    {msg.text} 
                  </div> 
                </div> 
              ))} 
            </div> 
            <form onSubmit={handleSend} className="p-2 border-t dark:border-gray-700 flex gap-1.5 bg-white dark:bg-gray-800"> 
              <input type="text" value={input} onChange={(e)=> setInput(e.target.value)} placeholder={t('yourMessage')} className="flex-1 bg-gray-100 dark:bg-gray-700 text-xs px-2.5 py-1.5 rounded-lg focus:outline-none focus:ring-1 focus:ring-be-france text-gray-800 dark:text-gray-100 transition-shadow focus:shadow-inner" /> 
              <button type="submit" className="bg-gradient-to-br from-be-france to-be-night text-white p-1.5 rounded-lg hover:brightness-110 transition-all shadow-md shadow-blue-600/30"> 
                <SafeIcon icon={LuSend} size={16} /> 
              </button> 
            </form> 
          </motion.div> 
        )} 
      </AnimatePresence> 
    </> 
  );
};
export default Chatbot;